import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiAward, FiClock, FiStar } from "react-icons/fi";

/** Best match / Short / Most points switcher for the survey marketplace. */
function SurveysSub() {
  const location = useLocation();
  const isActive = (NavLink) => location.pathname.includes(NavLink);
  const { t } = useTranslation();

  const tabs = [
    { to: "/my-surveys", label: t("side.bar.Best"), icon: FiStar },
    { to: "/short-survey", label: t("side.bar.Short"), icon: FiClock },
    { to: "/most-point", label: t("side.bar.Most"), icon: FiAward },
  ];

  return (
    <nav aria-label="Survey filters" className="w-full sm:w-auto">
      <div className="flex w-full zs-segmented sm:w-auto">
        {tabs.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            aria-current={isActive(to) ? "page" : undefined}
            className={`inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap text-center hover:text-ink sm:flex-none sm:px-4 ${
              isActive(to) ? "is-active" : ""
            }`}
          >
            <Icon className="hidden w-3.5 h-3.5 shrink-0 sm:block" aria-hidden="true" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default SurveysSub;
